<template>
	<el-container class="outer-container">
		<el-header><LayoutHeader /></el-header>
		<el-container class="h0">
			<el-aside><LayoutMenu /></el-aside>
			<el-main><RouterView /></el-main>
		</el-container>
	</el-container>
</template>

<script lang="ts">
export default {
	name: 'AppLayout',
}
</script>
<script lang="ts" setup>
import LayoutHeader from './LayoutHeader.vue'
import LayoutMenu from './LayoutMenu.vue'
</script>

<style lang="scss" scoped>
.el {
	&-container {
		&.outer-container {
			height: 100vh;
		}
	}
	&-header {
		height: $header-height;
	}
	&-aside {
		width: $aside-width;
		background-color: $color-white;
		box-shadow: inset -1px 0px 0px rgba(255, 255, 255, 0.1);
	}
	&-main {
		background-color: #f4f5f6;
		overflow: auto;
	}
}
</style>
